import { heroStats } from "@/mocks/manga";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20young%20reader%20relaxing%20with%20manga%20comics%20while%20floating%20manga%20comic%20panels%20and%20pages%20drift%20around%20them%2C%20warm%20coral%2C%20amber%20and%20cream%20color%20palette%2C%20energetic%20playful%20manga%20art%20style%2C%20flat%20vector%20comic%20illustration%2C%20clean%20dynamic%20composition%20with%20open%20space%20in%20center&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="汗汗虫虫漫画 - 追更阅读的插画背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>
      </div>

      <div className="relative mx-auto w-full max-w-6xl px-4 pb-16 pt-28 md:px-6 md:pb-24 md:pt-36">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/90 px-4 py-1.5 text-xs font-medium text-primary-700 shadow-soft">
            <i className="ri-calendar-check-line"></i>
            追更日历 · 更新状态随时掌握
          </span>

          <h1 className="mt-6 font-heading text-3xl leading-tight text-background-50 md:text-5xl md:leading-tight">
            不错过每一次更新
            <br className="hidden md:block" />
            <span className="text-accent-300">轻松追更</span> 认真阅读
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-sm leading-7 text-background-100 md:text-base">
            打开汗汗虫虫漫画，设置更新提醒与追更设置，最新章节推送自动通知，订阅管理一目了然。
            自动续读帮你接上次进度，追更日历整理所有在追作品，不用再反复刷新。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#works"
              className="w-full whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              开始追更
            </a>
            <a
              href="#features"
              className="w-full whitespace-nowrap rounded-md border border-background-100 bg-background-50/80 px-6 py-3 text-sm font-semibold text-foreground-900 backdrop-blur transition-colors hover:bg-background-50 sm:w-auto"
            >
              查看核心功能
            </a>
          </div>
        </div>

        <dl className="mx-auto mt-14 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-100/40 bg-background-50/85 p-4 text-center backdrop-blur"
            >
              <dt className="order-2 mt-1 text-xs text-foreground-600">{s.label}</dt>
              <dd className="order-1 font-heading text-2xl text-primary-600 md:text-3xl">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}